import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  buttonSize: {
    padding: theme.spacing(0.5, 0),
    fontSize: theme.typography.h6.fontSize
  },
  button: {
    marginRight: theme.spacing(1.5),
    color: theme.palette.jamii.brown
  }
}));
